import React from 'react';
import PropTypes from 'prop-types';
import './LockerComparisonHeader.scss';

export function LockerComparisonHeader({ title, description }) {
	return (
		<div className="locker-comparison-header">
			<h3 className="locker-comparison-header__title">{title}</h3>
			<p className="locker-comparison-header__description">
				{description}
			</p>
		</div>
	);
}

LockerComparisonHeader.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
};

export default LockerComparisonHeader;
